
export enum TextAlignment {
    Left = 1,
    Center = 2,
    Right = 3,
}